import { type TypeOf, isNotEmpty, z } from '@simplisafe/ewok'

export const seoNodeSchema = z.object({
  canonicalLink: z.string(),
  isNofollow: z.boolean(),
  isNoindex: z.boolean(),
  metaDescription: z
    .object({ metaDescription: z.string() })
    .default({ metaDescription: '' }),
  metaKeywords: z.array(z.string()),
  metaTitle: z.string().refine(isNotEmpty)
})

export type SeoNodeSchema = TypeOf<typeof seoNodeSchema>
